import React, { Component } from "react";
import "../../assets/web/assets/mobirise-icons2/mobirise2.css";
import "../../assets/web/assets/mobirise-icons/mobirise-icons.css";
import "../../assets/tether/tether.min.css";
import "../../assets/bootstrap/css/bootstrap.min.css";
import "../../assets/bootstrap/css/bootstrap-grid.min.css";
import "../../assets/bootstrap/css/bootstrap-reboot.min.css";
import "../../assets/dropdown/css/style.css";
import "../../assets/socicon/css/styles.css";
import "../../assets/theme/css/style.css";
import "../../assets/mobirise/css/mbr-additional.css";
import { Navbar, Nav } from "react-bootstrap";
import { Form, Button, Modal, Input } from "antd";
import loginimage from "../../assets/images/mbr-1-1920x1281.jpeg";
import { signIn, resetPassword } from "../../store/actions/authActions";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { toast } from "react-toastify";
import logo from "../../assets/images/logowhiterecmin.png";

class BusinessLoginPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      resetpassword: false,
    };
    this.handleChangePassword = this.handleChangePassword.bind(this);
    this.handleChangeEmail = this.handleChangeEmail.bind(this);
  }

  componentDidMount() {
    document.title = "Login";
  }

  handleChangePassword(event) {
    this.setState({ password: event.target.value });
  }

  handleChangeEmail(event) {
    this.setState({ email: event.target.value });
  }

  handleCancel = () => {
    this.setState({
      resetpassword: false,
    });
  };

  onFinish = () => {
    this.props.signIn({
      email: this.state.email,
      password: this.state.password,
    });
  };

  onFinishFailed = (errorInfo) => {
    toast.error("please check the form again.");
  };

  handleOkReset = (e) => {
    this.props.resetPassword(e.uemail);
    //this.props.sendEmail(e.uemail)
    this.setState({
      resetpassword: true,
    });
  };

  render() {
    if (!this.props.auth.uid || this.props.auth.isAnonymous)
      return (
        <div>
          <section
            className="menu menu2 cid-smIpILaFmX"
            once="menu"
            id="menu2-0"
          >
            <Navbar
              collapseOnSelect
              expand="lg"
              className="navbar navbar-dropdown navbar-fixed-top navbar-expand-lg"
              style={{ backgroundColor: "rgba(98, 98, 98, 0.5)" }}
            >
              <div className="container-fluid">
                <Navbar.Brand className="navbar-brand" href="#home">
                  <span className="navbar-logo">
                    <a href="/">
                      <img
                        src={logo}
                        alt="MassTaxi"
                        title=""
                        style={{ height: "2rem" }}
                      />
                    </a>
                  </span>
                </Navbar.Brand>
                <Navbar.Toggle
                  className="navbar-toggler"
                  type="button"
                  data-toggle="collapse"
                  data-target="#navbarSupportedContent"
                  aria-controls="navbarNavAltMarkup"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <div className="hamburger">
                    <span />
                    <span />
                    <span />
                    <span />
                  </div>
                </Navbar.Toggle>
                <Navbar.Collapse
                  className="collapse navbar-collapse"
                  id="navbarSupportedContent"
                >
                  <Nav className="navbar-nav nav-dropdown nav-right">
                    <Nav.Link
                      className="nav-link link text-white text-primary display-4"
                      href="#pricing"
                    >
                      About Us
                    </Nav.Link>
                    <Nav.Link
                      className="nav-link link text-white text-primary display-4"
                      href="/driver"
                    >
                      Driver
                    </Nav.Link>
                    <Nav.Link
                      className="nav-link link text-white text-primary display-4"
                      href="#business"
                    >
                      Business
                    </Nav.Link>
                  </Nav>
                </Navbar.Collapse>
              </div>
            </Navbar>
          </section>
          <section
            className="form3 cid-ssXbahqyMb mbr-fullscreen"
            id="form3-1s"
          >
            <div className="container-fluid">
              <div className="row justify-content-center">
                <div className="col-lg-7 col-12">
                  <div className="image-wrapper">
                    <img className="w-100" src={loginimage} alt="MassTaxi" />
                  </div>
                </div>
                <div
                  className="col-lg-3 offset-lg-1 mbr-form"
                  data-form-type="formoid"
                >
                  <Form
                    className="mbr-form form-with-styler"
                    onFinish={this.onFinish}
                    onFinishFailed={this.onFinishFailed}
                    data-form-title="Form Name"
                  >
                    <div className="dragArea row">
                      <div className="col-lg-12 col-md-12 col-sm-12">
                        <h1 className="mbr-section-title mb-4 display-2">
                          <strong>Log In</strong>
                        </h1>
                      </div>
                      <div className="col-lg-12 col-md-12 col-sm-12">
                        <p className="mbr-text mbr-fonts-style mb-4 display-7">
                          Check your Business's AD status
                        </p>
                      </div>
                      <div
                        className="col-lg-12 col-md col-sm-12 form-group"
                        data-for="email"
                      >
                        <input
                          type="email"
                          name="email"
                          minLength="5"
                          maxLength="100"
                          placeholder="Representative Email"
                          required
                          data-form-field="email"
                          className="form-control"
                          value={this.state.email}
                          onChange={this.handleChangeEmail}
                          id="email-form3-1s"
                        />
                      </div>
                      <div
                        data-for="password"
                        className="col-lg-12 col-md col-sm-12 form-group"
                      >
                        <input
                          type="password"
                          name="name"
                          placeholder="Password"
                          minLength="8"
                          maxLength="25"
                          required
                          data-form-field="password"
                          className="form-control"
                          value={this.state.password}
                          onChange={this.handleChangePassword}
                          id="password-form3-1s"
                        />
                      </div>
                      <div className="col-lg-12 col-md col-sm-12 form-group">
                        <a
                          className="navbar-caption text-white display-7"
                          style={{ textDecoration: "underline" }}
                          href="/business_register"
                        >
                          I Don't Have An Account, Register
                        </a>
                      </div>
                      <div className="col-md-auto col-12 mbr-section-btn">
                        <Button
                          type="primary"
                          className="btn btn-black display-4"
                          htmlType="submit"
                        >
                          Log In
                        </Button>
                      </div>
                      <div className="col-lg-12 col-md col-sm-12 form-group">
                        <p className="mbr-text mbr-fonts-style mt-3 display-7 col-12 text-right">
                          <span
                            onClick={() => {
                              this.setState({
                                resetpassword: true,
                              });
                            }}
                            className="text-primary"
                            id="forgotpassword"
                          >
                            Forgot Password
                          </span>
                        </p>
                      </div>
                    </div>
                  </Form>
                </div>
                <div className="offset-lg-1" />
              </div>
            </div>
          </section>
          <section
            className="footer3 cid-smIvGalAcO"
            once="footers"
            id="footer3-1u"
          >
            <div className="container">
              <div className="media-container-row align-center mbr-white">
                <div className="row row-links">
                  <ul className="foot-menu">
                    <li className="foot-menu-item mbr-fonts-style display-7">
                      <a href="/" className="text-primary">
                        Home
                      </a>
                    </li>
                    <li className="foot-menu-item mbr-fonts-style display-7">
                      <a href="/contacts" className="text-primary">
                        Contact Us
                      </a>
                    </li>
                    <li className="foot-menu-item mbr-fonts-style display-7">
                      <a href="/driver" className="text-primary">
                        Driver
                      </a>
                    </li>
                    <li className="foot-menu-item mbr-fonts-style display-7">
                      <a href="/business_login" className="text-primary">
                        Login
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="row social-row">
                  <div className="social-list align-right pb-2">
                    <div className="soc-item">
                      <a
                        href="https://www.facebook.com/masstaxiads"
                        rel="noreferrer"
                        target="_blank"
                      >
                        <span className="socicon-facebook socicon mbr-iconfont mbr-iconfont-social" />
                      </a>
                    </div>
                    <div className="soc-item">
                      <a
                        href="https://www.youtube.com/channel/UCsBTZqPsr-ceq197Fz1gYcw"
                        rel="noreferrer"
                        target="_blank"
                      >
                        <span className="socicon-youtube socicon mbr-iconfont mbr-iconfont-social" />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="row row-copirayt">
                  <p className="mbr-text mb-0 mbr-fonts-style mbr-white align-center display-7">
                    © MassTaxi 2021. Service Provided by DAST ICT Solutions PLC.
                    All Rights Reserved.
                  </p>
                </div>
              </div>
            </div>
          </section>
          <Modal
            title="Reset Password"
            visible={this.state.resetpassword}
            onCancel={this.handleCancel}
            footer={null}
          >
            <div style={{ textAlign: "center" }}>
              <Form
                style={{ offset: 2, span: 20 }}
                name="basic"
                initialValues={{ remember: true }}
                onFinish={this.handleOkReset}
                onFinishFailed={this.onFinishFailed}
              >
                <Form.Item
                  label="User Email"
                  name="uemail"
                  rules={[
                    {
                      required: true,
                      message: "Please input Your User Email!",
                    },
                  ]}
                >
                  <Input
                    style={{ width: "100%" }}
                    placeholder="User Email Here"
                    minLength={4}
                    maxLength={50}
                    type="email"
                  />
                </Form.Item>

                <Form.Item>
                  <Button
                    onClick={this.handleCancel}
                    type="default"
                    htmlType="button"
                    style={{
                      marginRight: "2rem",
                    }}
                  >
                    Cancel
                  </Button>

                  <Button type="primary" htmlType="submit">
                    Submit
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </Modal>
        </div>
      );
    return <Redirect to="/" />;
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    signIn: (creds) => dispatch(signIn(creds)),
    resetPassword: (email) => dispatch(resetPassword(email)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BusinessLoginPage);
